export default __webpack_public_path__ + "static/media/grid15.10065663.png";